export default {
  authenticated: false,
  user: null,
  userToken: null, // jwt
  userProfile: {},
};
